import { FLAGS } from '@/config/feature-flags';
import { useGatedFlagAccess, type GatedFlagAccess } from './use-gated-flag-access';

export type IntelligenceAudienceAccess = GatedFlagAccess;

/**
 * Whether the audience-scoped Intelligence surfaces are open to this user: the audience page
 * and the Intelligence tab that opens it, and the account and contact profile pages.
 *
 * **One hook for all three, because they are one feature.** Both profile pages carry the
 * audience in their path (`/intelligence/audiences/:audienceId/accounts/:domHash`) and
 * everything on them — the play, the committee, the ICP counts — is computed against that
 * audience's filters. Without the switcher there is no audience to arrive with.
 *
 * It is also the only way the three can be made to agree. `useFeatureFlag` alone answers
 * from Flagsmith and knows nothing about the e2e override, so a rail reading the flag
 * directly while the routes read this hook would show the card on a page whose links all
 * bounce — which is exactly what the first cut of this did.
 *
 * Fail-closed via the registry default (`false`): an unreachable Flagsmith hides them
 * rather than exposing them.
 *
 * **A product gate, not enforcement.** The backend carries no Flagsmith SDK, so
 * `GET /intelligence/audiences/{id}/accounts/{domHash}` stays reachable whatever this
 * returns. Anything that must actually be refused belongs server-side.
 */
export const useIntelligenceAudienceAccess = (): IntelligenceAudienceAccess =>
  useGatedFlagAccess(FLAGS.intelligenceAudienceSwitcher, '__FF_INTELLIGENCE_AUDIENCE_SWITCHER__');
